import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { ColumnsType } from "antd/es/table";
import { AuthRoles } from "@lib/types/Auth";
import { TableColumnsProps } from "@lib/types/General";
import { AILog } from "@lib/types/AILog";
import {
  CoinPriceTextFormat,
  CustomerName,
  WalletAddressText,
} from "@lib/components/MiniComponents/Others";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import CallLength from "@lib/components/MiniComponents/Others/CallLength";

type Props<T> = TableColumnsProps<T> & {
  userRole?: AuthRoles;
  handleSelect: (item: AILog) => void;
};

const getColumns = <T extends AILog>(props: Props<T>): ColumnsType<T> => {
  const { handleSelect } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      render: (v, r) => (
        <TableIdButton
          // link={`/payment_history/list/${r.id}`}
          text={`#${shortenString(r.id)}`}
          textToBeCopied={r.id}
        />
      ),
      width: "180px",
      filterType: "search",
    },
    {
      title: "common.customer",
      dataIndex: "customer.id",
      key: "customer.name",
      width: "180px",
      render: (_, r) => <CustomerName customer={r?.customer} link />,
    },
    {
      title: "common.cost",
      dataIndex: "cost",
      width: "100px",
      render: (_, r) => (
        <CoinPriceTextFormat
          amount={r?.cost || 0}
          currency={r?.currency}
          showCurrencySymbol
          showAllDigits
          maxDigits={5}
        />
      ),
    },
    {
      title: "common.actualCost",
      dataIndex: "actualCost",
      width: "100px",
      render: (_, r) => (
        <CoinPriceTextFormat
          amount={r?.actualCost || 0}
          currency={r?.currency}
          showCurrencySymbol
          showAllDigits
          maxDigits={5}
        />
      ),
    },
    {
      title: "common.callLength",
      dataIndex: "callLength",
      width: "100px",
      align: "right",
      render: (_, r) => <CallLength callLength={r?.callLength || 0} />,
    },
    {
      title: "common.task",
      dataIndex: "task",
      filterType: "dropdown",
      width: "200px",
    },
    {
      title: "common.modelId",
      dataIndex: "modelId",
      filterType: "dropdown",
      width: "100px",
      render: (_, r) => (
        <TableIdButton text={`#${shortenString(r.modelId, 30)}`} />
      ),
    },
    {
      title: "common.walletAddress",
      dataIndex: "walletAddress.address",
      width: "180px",
      render: (_, r) => <WalletAddressText walletAddress={r?.walletAddress} />,
      filterType: "search",
    },

    {
      title: "common.createdAt",
      dataIndex: "createdAt",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "110px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="quickLook"
            onClick={() => handleSelect(record)}
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
